import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { FreecodeLoading } from 'components/FreecodePage/FreecodeLoading/FreecodeLoading';
import FreecodePage from 'components/FreecodePage/FreecodePage';
import { useFreecodeContextLayout } from 'hooks/useContext';
import FreecodeLayout from 'components/FreecodePage/FreecodeLayout/FreecodeLayout';
import { identifiers, editorTypes } from 'components/FreecodePage/FreecodeLayout/FreecodeLayoutConstants';
import FreecodeDiscussion from 'components/FreecodePage/FreecodeTabs/FreecodeDiscussion/FreecodeDiscussion';
import SubmitChallengeModal from 'components/Modals/FreecodeModals/SubmitChallengeModal';
import FreecodeMobilePromptModal from 'components/Modals/FreecodeModals/FreecodeMobilePromptModal';
import useChallengeRunFunction from './useChallengeRunFunction';
import useChallengeLoadFunction from './useChallengeLoadFunction';
import { sendAnalytics } from 'functions/sendAnalytics';

const HEADER_LINKS = [{ link: '/challenges', label: 'All Challenges' }];

export default function FreecodeChallenge() {
  const { contestId } = useParams();

  const [challengeComponents, setChallengeComponents] = useState({});

  const { displaySubmit, setEditorType } = useFreecodeContextLayout();

  const { contest, loading, error } = useChallengeLoadFunction(contestId);
  useChallengeRunFunction();

  useEffect(() => {
    setEditorType(editorTypes.contest);
  }, [setEditorType]);

  useEffect(() => {
    if (!contestId || !contest?.test) return;
    sendAnalytics('openChallenge', contestId);
    setChallengeComponents((e) => ({
      ...e,
      [identifiers.discussion]: <FreecodeDiscussion testId={contest.test} contestId={contestId} />,
    }));
  }, [contestId, contest]);

  return (
    <FreecodePage headerLinks={HEADER_LINKS} contest={contest}>
      <FreecodeLoading loading={loading} errors={[error]} errorLinkText="All Challenges" errorLink="/challenges" />
      {!loading && <FreecodeLayout parentComponents={challengeComponents} />}
      {displaySubmit && <SubmitChallengeModal contest={contest} />}
      <FreecodeMobilePromptModal type="challenge" id={contestId} />
    </FreecodePage>
  );
}
